import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSplitPolygon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 18,
	viewBox: "0 0 21 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.876 5.076C7.083 4.626 7.2 4.131 7.2 3.6C7.2 1.611 5.589 0 3.6 0C1.611 0 0 1.611 0 3.6C0 5.589 1.611 7.2 3.6 7.2C4.131 7.2 4.626 7.083 5.076 6.876L7.2 9L5.076 11.124C4.626 10.917 4.131 10.8 3.6 10.8C1.611 10.8 0 12.411 0 14.4C0 16.389 1.611 18 3.6 18C5.589 18 7.2 16.389 7.2 14.4C7.2 13.869 7.083 13.374 6.876 12.924L9 10.8L15.3 17.1H18V16.2L6.876 5.076ZM3.6 5.4C2.61 5.4 1.8 4.599 1.8 3.6C1.8 2.601 2.61 1.8 3.6 1.8C4.59 1.8 5.4 2.601 5.4 3.6C5.4 4.599 4.59 5.4 3.6 5.4ZM3.6 16.2C2.61 16.2 1.8 15.399 1.8 14.4C1.8 13.401 2.61 12.6 3.6 12.6C4.59 12.6 5.4 13.401 5.4 14.4C5.4 15.399 4.59 16.2 3.6 16.2ZM9 9.45C8.748 9.45 8.55 9.252 8.55 9C8.55 8.748 8.748 8.55 9 8.55C9.252 8.55 9.45 8.748 9.45 9C9.45 9.252 9.252 9.45 9 9.45ZM15.3 0.9L9.9 6.3L11.7 8.1L18 1.8V0.9L15.3 0.9Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20 9L12 9",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeDasharray: "2 2"
	})]
});
export default SvgSplitPolygon;
